var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../../../nunjucks.config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["front/utils/macros.jinja"] = require( "front/utils/macros.jinja" );




var shim = require("/var/www/django/gbn.moscow/application/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["assets/app/front/components/IndexSlider/IndexSlider.jinja"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = 0;
var colno = 0;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("front/utils/macros.jinja", false, "assets/app/front/components/IndexSlider/IndexSlider.jinja", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
context.setVariable("macros", t_1);
output += "\n\n\n<div class=\"IndexSlider\">\n    <div class=\"IndexSlider-side\">\n        <div class=\"IndexSlider-sideSlider\">\n            ";
frame = frame.push();
var t_6 = runtime.contextOrFrameLookup(context, frame, "workers");
if(t_6) {t_6 = runtime.fromIterator(t_6);
var t_5 = t_6.length;
for(var t_4=0; t_4 < t_6.length; t_4++) {
var t_7 = t_6[t_4];
frame.set("worker", t_7);
frame.set("loop.index", t_4 + 1);
frame.set("loop.index0", t_4);
frame.set("loop.revindex", t_5 - t_4);
frame.set("loop.revindex0", t_5 - t_4 - 1);
frame.set("loop.first", t_4 === 0);
frame.set("loop.last", t_4 === t_5 - 1);
frame.set("loop.length", t_5);
output += "\n                <div class=\"IndexSlider-slide IndexSlider-slide--side ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "loop")),"first")) {
output += "IndexSlider-slide--isActive";
;
}
output += "\"\n                     data-id=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "loop")),"index0"), env.opts.autoescape);
output += "\">\n                    <img class=\"IndexSlider-slideImg\" src=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((t_7),"img_small")),"w300"), env.opts.autoescape);
output += "\"\n                         srcset=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((t_7),"img_small")),"w600"), env.opts.autoescape);
output += " 2x\">\n                    <div class=\"IndexSlider-slideBorder\"></div>\n                </div>\n            ";
;
}
}
frame = frame.pop();
output += "\n        </div>\n        <div class=\"IndexSlider-nav\">\n            <div class=\"IndexSlider-navItem IndexSlider-navItem--prev IndexSlider-navItem--isDisabled\">\n                ";
output += runtime.suppressValue((lineno = 17, colno = 40, runtime.callWrap(runtime.memberLookup((t_1),"svgSprite"), "macros[\"svgSprite\"]", context, ["arrow",runtime.makeKeywordArgs({"caller": (function (){var macro_t_8 = runtime.makeMacro(
[], 
[], 
function (kwargs) {
var callerFrame = frame;
frame = frame.push(true);
kwargs = kwargs || {};
if (Object.prototype.hasOwnProperty.call(kwargs, "caller")) {
frame.set("caller", kwargs.caller); }
var t_9 = "";;
frame = frame.pop();
return new runtime.SafeString(t_9);
});
return macro_t_8;})()})])), env.opts.autoescape);
output += "</div>\n            <div class=\"IndexSlider-navItem IndexSlider-navItem--next\">\n                ";
output += runtime.suppressValue((lineno = 19, colno = 40, runtime.callWrap(runtime.memberLookup((t_1),"svgSprite"), "macros[\"svgSprite\"]", context, ["arrow",runtime.makeKeywordArgs({"caller": (function (){var macro_t_10 = runtime.makeMacro(
[], 
[], 
function (kwargs) {
var callerFrame = frame;
frame = frame.push(true);
kwargs = kwargs || {};
if (Object.prototype.hasOwnProperty.call(kwargs, "caller")) {
frame.set("caller", kwargs.caller); }
var t_11 = "";;
frame = frame.pop();
return new runtime.SafeString(t_11);
});
return macro_t_10;})()})])), env.opts.autoescape);
output += "</div>\n        </div>\n    </div>\n    <div class=\"IndexSlider-main\">\n        <div class=\"IndexSlider-mainSlider owl-carousel\">\n            ";
frame = frame.push();
var t_14 = runtime.contextOrFrameLookup(context, frame, "workers");
if(t_14) {t_14 = runtime.fromIterator(t_14);
var t_13 = t_14.length;
for(var t_12=0; t_12 < t_14.length; t_12++) {
var t_15 = t_14[t_12];
frame.set("worker", t_15);
frame.set("loop.index", t_12 + 1);
frame.set("loop.index0", t_12);
frame.set("loop.revindex", t_13 - t_12);
frame.set("loop.revindex0", t_13 - t_12 - 1);
frame.set("loop.first", t_12 === 0);
frame.set("loop.last", t_12 === t_13 - 1);
frame.set("loop.length", t_13);
output += "\n                <div class=\"IndexSlider-slide IndexSlider-slide--main\" data-id=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "loop")),"index0"), env.opts.autoescape);
output += "\">\n                    <img class=\"IndexSlider-slideImg\" src=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((t_15),"img")),"w600"), env.opts.autoescape);
output += "\"\n                         srcset=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((t_15),"img")),"w900"), env.opts.autoescape);
output += " 900w, ";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((t_15),"img")),"w1200"), env.opts.autoescape);
output += " 1200w, ";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((t_15),"img")),"w1800"), env.opts.autoescape);
output += " 1800w, ";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((t_15),"img")),"w2400"), env.opts.autoescape);
output += " 2400w\">\n                    <div class=\"IndexSlider-slideInfo\">\n                        <div class=\"IndexSlider-slideInfoMain\">\n                            <div class=\"IndexSlider-slideName\">";
output += runtime.suppressValue(runtime.memberLookup((t_15),"name"), env.opts.autoescape);
output += "</div>\n                            <div class=\"IndexSlider-slideDesc\">";
output += runtime.suppressValue(runtime.memberLookup((t_15),"position"), env.opts.autoescape);
output += "</div>\n                        </div>\n                        <div class=\"IndexSlider-slideDealNumber\">";
output += runtime.suppressValue(runtime.memberLookup((t_15),"dealsCount"), env.opts.autoescape);
output += " ";
output += runtime.suppressValue(runtime.memberLookup((t_15),"dealsText"), env.opts.autoescape);
output += "</div>\n                        ";
if(runtime.memberLookup((t_15),"isBestYear")) {
output += "\n                            <div class=\"IndexSlider-slideAdditional\">Лучший эксперт года</div>";
;
}
output += "\n                        ";
if(runtime.memberLookup((t_15),"isBestMonth")) {
output += "\n                            <div class=\"IndexSlider-slideAdditional IndexSlider-slideAdditional--month\">Лучший эксперт месяца</div>";
;
}
output += "\n                    </div>\n                </div>\n            ";
;
}
}
frame = frame.pop();
output += "\n        </div>\n        <div class=\"IndexSlider-mainNav\">\n            <div class=\"IndexSlider-mainNav-item IndexSlider-mainNav-item--top\"></div>\n            <div class=\"IndexSlider-mainNav-item IndexSlider-mainNav-item--bottom\"></div>\n        </div>\n    </div>\n</div>";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["assets/app/front/components/IndexSlider/IndexSlider.jinja"] , dependencies)


//////////////////
// WEBPACK FOOTER
// ./assets/app/front/components/IndexSlider/IndexSlider.jinja
// module id = 31
// module chunks = 0